import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

import {YmLogger} from './YmLogger';

export const useMenuAnalytics = () => {
  const userInfo = useAuthorizedProfile();

  const logMenuOpen = () => {
    logTmrEvent({
      logEvent: 'menu.open',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logMenuOpenClick();
  };

  const logMenuClose = () => {
    logTmrEvent({
      logEvent: 'menu.close',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });
  };

  const logMenuAppsClick = () => {
    logTmrEvent({
      logEvent: 'menu.apps.click',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logAppsClick();
  };

  const logMenuGamesClick = () => {
    logTmrEvent({
      logEvent: 'menu.games.click',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logGamesClick();
  };

  const logMenuDevClick = () => {
    logTmrEvent({
      logEvent: 'menu.dev.click',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logDevClick();
  };

  const logMenuSupportClick = () => {
    logTmrEvent({
      logEvent: 'menu.support.click',
      params: {
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logSupportClick();
  };

  return {
    logMenuOpen,
    logMenuClose,
    logMenuAppsClick,
    logMenuGamesClick,
    logMenuDevClick,
    logMenuSupportClick,
  };
};
